var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInnovationDefault = function SvgInnovationDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "atom/icon/navigation/innovation/default")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/navigation/innovation/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(24.000000, 21.000000)",
    stroke: "#353531",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mesa-de-trabajo-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeLinecap: "round",
    points: "10.3088172 21.5741935 5.4916129 21.5741935 4.28731183 20.3913978 4.28731183 16.8430108 11.5131183 16.8430108 11.5131183 20.3913978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5131183,16.8430108 L11.5131183,15.4591398 C11.4957407,14.2309923 11.9868764,13.0485566 12.8739785,12.1827957 C14.2892425,10.9719674 15.108986,9.22398496 15.1260215,7.38064516 C15.1260215,3.461205 11.8909178,0.283870968 7.90021505,0.283870968 C3.90951235,0.283870968 0.674408602,3.461205 0.674408602,7.38064516 C0.696028044,9.22550858 1.52001894,10.973202 2.93849462,12.1827957 C3.8223601,13.0497621 4.3092592,14.2324643 4.28731183,15.4591398 L4.28731183,16.8430108",
    id: "Path"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInnovationDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/innovation-default.9b90381c.svg";
export { ForwardRef as ReactComponent };